import { Checkbox, FormControlLabel, Grid } from '@mui/material';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import { PersonalDataVM } from 'shell/view-models/personal-data';

interface GeneralityComponentProps {
  onChange: (key: keyof PersonalDataVM, value: PersonalDataVM[keyof PersonalDataVM]) => void;
  values?: PersonalDataVM;
  resetForm?: () => void;
  onSearch: () => void;
  disabled?: boolean;
  onChangeFields: (values: PersonalDataVM) => void;
}

const GeneralityComponent = ({
  onChange,
  values,
  resetForm,
  onSearch,
  disabled,
  onChangeFields,
}: GeneralityComponentProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Codice fiscale"
          aria-label="Codice fiscale"
          id="fiscal-code"
          fullWidth
          value={values?.fiscalCode?.toUpperCase() || ''}
          onChange={(event) => onChange('fiscalCode', event.target.value)}
          disabled={disabled}
          inputProps={{ maxLength: '16' }}
        />
      </Grid>
      <Grid item container spacing={1} xs={12} alignItems="center">
        <Grid item xs={12} md={9}>
          <PmiTextField
            label="Cognome"
            aria-label="Cognome"
            id="surname"
            fullWidth
            value={values?.surname || ''}
            onChange={(event) => onChange('surname', event.target.value)}
            disabled={disabled || values?.withoutSurname}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                id="withoutSurname"
                checked={values?.withoutSurname}
                onChange={() =>
                  onChangeFields({
                    surname: !values?.withoutSurname ? '' : values?.surname || '',
                    withoutSurname: !values?.withoutSurname,
                  })
                }
                disabled={disabled}
                inputProps={{ 'aria-label': 'Persona senza cognome' }}
              />
            }
            label="Persona senza cognome"
          />
        </Grid>
      </Grid>
      <Grid item container spacing={1} xs={12} alignItems="center">
        <Grid item xs={12} md={9}>
          <PmiTextField
            label="Nome"
            aria-label="Nome"
            id="name"
            fullWidth
            value={values?.name || ''}
            onChange={(event) => onChange('name', event.target.value)}
            disabled={disabled || values?.withoutName}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                id="withoutName"
                checked={values?.withoutName}
                onChange={() =>
                  onChangeFields({
                    name: !values?.withoutName ? '' : values?.name || '',
                    withoutName: !values?.withoutName,
                  })
                }
                disabled={disabled}
                inputProps={{ 'aria-label': 'Persona senza nome' }}
              />
            }
            label="Persona senza nome"
          />
        </Grid>
      </Grid>
      <Grid item container spacing={1} alignItems="center" xs={12}>
        <Grid item xs={12} md={4}>
          <PmiButton
            variant="contained"
            color="secondary"
            fullWidth
            disabled={
              !values?.fiscalCode &&
              !(
                (values?.name || values?.withoutName) &&
                (values?.surname || values?.withoutSurname)
              )
            }
            onClick={onSearch}
          >
            Cerca
          </PmiButton>
        </Grid>
        {resetForm ? (
          <Grid item xs={12} md={2}>
            <PmiButton variant="outlined" color="cdmBrand" fullWidth onClick={resetForm}>
              Pulisci
            </PmiButton>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};

GeneralityComponent.displayName = 'FormFilter component for new person page';

const FormFilterNewPerson = memo(GeneralityComponent);

export default FormFilterNewPerson;
